// src/platform/dashboards/UnbuiltDashboard.jsx
//
// Fallback for a dashboard the API reports but the UI has no component for.
//
// This is NOT an error state. The API owns which dashboards exist; a backend
// rollup can legitimately ship before its view, and that ordering is the
// expected one — there has to be something to open before a view is worth
// building. So the card appears, opens, and explains itself.

import React from "react";
import { LayoutDashboard } from "lucide-react";

export default function UnbuiltDashboard({ dashboardKey, title }) {
  return (
    <div className="p-6">
      <div className="rounded-lg border border-bg-border bg-bg-soft px-5 py-6 max-w-xl">
        <LayoutDashboard size={18} className="text-fg-secondary" />
        <h3 className="text-sm font-semibold text-fg-primary mt-3">
          {title || dashboardKey} has no view yet
        </h3>
        <p className="text-xs text-fg-secondary mt-1.5 leading-relaxed">
          The platform is reporting this dashboard and its rollup, but no component is
          registered for <code className="text-fg-primary">{dashboardKey}</code>. Register
          one in <code className="text-fg-primary">platform/dashboards/dashboardRegistry.js</code>.
        </p>
      </div>
    </div>
  );
}
